import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_contact",
  "use": "icon-icon_contact-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_contact\">\n    <path d=\"M2 0C0.906937 0 0 0.906937 0 2V6C0 7.09306 0.906937 8 2 8H6C7.09306 8 8 7.09306 8 6V2C8 0.906937 7.09306 0 6 0H2ZM2 2H6V6H2V2ZM2 10V12H4V10H2ZM12 10C10.9069 10 10 10.9069 10 12V16C10 17.0931 10.9069 18 12 18H16C17.0931 18 18 17.0931 18 16V12C18 10.9069 17.0931 10 16 10H12ZM12 12H16V16H12V12ZM2 14V16H4V14H2ZM6 14V16H8V14H6Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol